type IconMysteryProps = {
    className?: string;
};

export function IconMystery(props: IconMysteryProps) {
    const { className = '' } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={true}
            className={`${className}`}
        >
            <mask
                id="mask0_6947_18945"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6947_18945)">
                <path
                    d="M11 18C12.9333 18 14.5833 17.3208 15.95 15.9625C17.3167 14.6042 18 12.95 18 11C18 9.06667 17.3167 7.41667 15.95 6.05C14.5833 4.68333 12.9333 4 11 4C9.05 4 7.39583 4.68333 6.0375 6.05C4.67917 7.41667 4 9.06667 4 11C4 12.95 4.67917 14.6042 6.0375 15.9625C7.39583 17.3208 9.05 18 11 18ZM11 15C9.61667 15 8.3875 14.6292 7.3125 13.8875C6.2375 13.1458 5.46667 12.1833 5 11C5.46667 9.83333 6.2375 8.875 7.3125 8.125C8.3875 7.375 9.61667 7 11 7C12.3667 7 13.5875 7.375 14.6625 8.125C15.7375 8.875 16.5167 9.83333 17 11C16.5167 12.1833 15.7375 13.1458 14.6625 13.8875C13.5875 14.6292 12.3667 15 11 15ZM11 13.5C11.9167 13.5 12.7583 13.2792 13.525 12.8375C14.2917 12.3958 14.8917 11.7833 15.325 11C14.8917 10.2333 14.2917 9.625 13.525 9.175C12.7583 8.725 11.9167 8.5 11 8.5C10.0667 8.5 9.21667 8.725 8.45 9.175C7.68333 9.625 7.08333 10.2333 6.65 11C7.08333 11.7833 7.68333 12.3958 8.45 12.8375C9.21667 13.2792 10.0667 13.5 11 13.5ZM11 12.5C11.4167 12.5 11.7708 12.3583 12.0625 12.075C12.3542 11.7917 12.5 11.4333 12.5 11C12.5 10.5833 12.3542 10.2292 12.0625 9.9375C11.7708 9.64583 11.4167 9.5 11 9.5C10.5667 9.5 10.2083 9.64583 9.925 9.9375C9.64167 10.2292 9.5 10.5833 9.5 11C9.5 11.4333 9.64167 11.7917 9.925 12.075C10.2083 12.3583 10.5667 12.5 11 12.5ZM11 20C9.75 20 8.57917 19.7625 7.4875 19.2875C6.39583 18.8125 5.44583 18.1708 4.6375 17.3625C3.82917 16.5542 3.1875 15.6042 2.7125 14.5125C2.2375 13.4208 2 12.25 2 11C2 9.76667 2.2375 8.60417 2.7125 7.5125C3.1875 6.42083 3.82917 5.46667 4.6375 4.65C5.44583 3.83333 6.39583 3.1875 7.4875 2.7125C8.57917 2.2375 9.75 2 11 2C12.2333 2 13.3958 2.2375 14.4875 2.7125C15.5792 3.1875 16.5333 3.83333 17.35 4.65C18.1667 5.46667 18.8125 6.42083 19.2875 7.5125C19.7625 8.60417 20 9.76667 20 11C20 12.0667 19.825 13.075 19.475 14.025C19.125 14.975 18.6417 15.8417 18.025 16.625L22 20.6L20.575 22L16.6 18.05C15.8167 18.6667 14.95 19.1458 14 19.4875C13.05 19.8292 12.05 20 11 20Z"
                    fill="black"
                />
            </g>
        </svg>
    );
}

export default IconMystery;
